'use strict';

const iconTokens = (theme) => ({
    iconDefaultFontSize: theme.typography.fontSize.m,
    iconFontSizeS: theme.typography.fontSize.s,
    iconFontSizeL: theme.typography.fontSize.xl,
    iconFontSizeXL: theme.typography.fontSize.xxxl,
    iconPlaceholderBackgroundColor: theme.colors.border,
    iconPlaceholderBorderRadius: theme.radiuses.m,
    iconIntentPrimaryColor: theme.colors.primary.normal,
    iconIntentDangerColor: theme.colors.danger.normal,
    iconIntentDisabledColor: theme.colors.disabled.text,
    iconIntentSuccessColor: theme.colors.success.normal,
    iconIntentWarningColor: theme.colors.warning.normal,
});

exports.iconTokens = iconTokens;
//# sourceMappingURL=icon.js.map
